



































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import singleChoice from "./previewSetting/singleChoice.vue";
import singleChoicePicker from "./previewSetting/singleChoicePicker.vue";
import multipleChoice from "./previewSetting/multipleChoice.vue";
import sort from "./previewSetting/sort.vue";
import proportion from "./previewSetting/proportion.vue";
import multipleChoicePicker from "./previewSetting/multipleChoicePicker.vue";
import fillIn from "./previewSetting/fillIn.vue";
import phoneNumber from "./previewSetting/phoneNumber.vue";
import cascade from "./previewSetting/cascade.vue";
import uploadAddon from "./previewSetting/uploadAddon.vue";
import imageSetting from "./previewSetting/imageSetting.vue";
import textSetting from "./previewSetting/textSetting.vue";
import fillInMulti from "./previewSetting/fillInMulti.vue";
import fillInRange from "./previewSetting/fillInRange.vue";
import fillInTable from "./previewSetting/fillInTable.vue";
import dateTime from "./previewSetting/dateTime.vue";
import addressInput from "./previewSetting/addressInput.vue";
import cutOffLine from "./previewSetting/cutOffLine.vue";
import pageGap from "./previewSetting/pageGap.vue";
import calculator from "./previewSetting/calculator.vue";
import patientName from "./previewSetting/patientName.vue";
import age from "./previewSetting/age.vue";
import sex from "./previewSetting/sex.vue";
import diagnosisTime from "./previewSetting/diagnosisTime.vue";
import diagnosis from "./previewSetting/diagnosis.vue";
import onlineBooking from "./previewSetting/onlineBooking.vue";
import department from "./previewSetting/department.vue";
import empty from "@/modules/community/pages/components/empty.vue";

import draggable from "vuedraggable";
import { DecorationType, QuestionType } from "@/modules/newCommunity/pages/operationTools/config/newQuestionnaire";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
@Component({
  name: "ModulesPreview",
  components: {
    empty,
    draggable,
    singleChoice,
    singleChoicePicker,
    multipleChoice,
    sort,
    proportion,
    multipleChoicePicker,
    fillIn,
    phoneNumber,
    cascade,
    uploadAddon,
    imageSetting,
    textSetting,
    fillInMulti,
    fillInRange,
    fillInTable,
    dateTime,
    addressInput,
    cutOffLine,
    pageGap,
    calculator,
    patientName,
    age,
    sex,
    diagnosisTime,
    diagnosis,
    onlineBooking,
    department,
  },
  filters: {},
})
export default class ModulesPreview extends Vue {
  // $refs!: {
  //   ruleForm: HTMLFormElement;
  // };
  private dataList2: any = [];
  @Prop({ type: Array, default: () => [] }) cmpsData!: any;
  @Prop({ type: Array, default: () => [] }) pretendData!: any;

  private uniqueArr = [25, 26, 27, 28, 29];

  private drag = false;
  get activeIndex() {
    return QuestionnaireEditModule.activeIndex;
  }
  get action() {
    return QuestionnaireEditModule.action;
  }
  private get basicData() {
    return QuestionnaireEditModule.basicData;
  }
  get dataList() {
    console.warn("dataList", QuestionnaireEditModule.dataList);
    return QuestionnaireEditModule.dataList;
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }

  private get isModel() {
    return QuestionnaireEditModule.isModel;
  }

  @Watch("dataList")
  listenList(value: any) {
    console.log("dataListwatch", value);
    this.dataList2 = value;
  }
  created() {
    this.dataList2 = QuestionnaireEditModule.dataList;
  }

  private componentName(item: any) {
    if (item) {
      switch (item.componentName) {
        case QuestionType.singleChoice:
          return "singleChoice";
        case QuestionType.singleChoicePicker:
          return "singleChoicePicker";
        case QuestionType.multipleChoice:
          return "multipleChoice";
        case QuestionType.sort:
          return "sort";
        case QuestionType.proportion:
          return "proportion";
        case QuestionType.multipleChoicePicker:
          return "multipleChoicePicker";
        case QuestionType.phoneNumber:
          return "phoneNumber";
        case QuestionType.fillIn:
          return "fillIn";
        case QuestionType.fillInMulti:
          return "fillInMulti";
        case QuestionType.fillInRange:
          return "fillInRange";
        case QuestionType.dateTime:
          return "dateTime";
        case QuestionType.addressInput:
          return "addressInput";
        case QuestionType.cascade:
          return "cascade";
        case QuestionType.uploadAddon:
          return "uploadAddon";
        case QuestionType.fillInTable:
          return "fillInTable";
        case DecorationType.picture:
          return "imageSetting";
        case DecorationType.text:
          return "textSetting";
        case DecorationType.pageGap:
          return "pageGap";
        case DecorationType.cutOffLine:
          return "cutOffLine";
        case DecorationType.calculator:
          return "calculator";
        case QuestionType.patientName:
          return "patientName";
        case QuestionType.age:
          return "age";
        case QuestionType.sex:
          return "sex";
        case QuestionType.diagnosisTime:
          return "diagnosisTime";
        case QuestionType.diagnosis:
          return "diagnosis";
        case QuestionType.onlineBooking:
          return "onlineBooking";
        case QuestionType.department:
          return "department";
      }
    }
    return "";
  }

  // $ 标题点击
  private titleClick() {
    // QuestionnaireEditModule.SET_BASICS_DATA();
  }

  // $ 开始拖拽
  private onStart() {
    this.drag = true;
  }
  // $ 结束拖拽
  private onEnd() {
    this.drag = false;
    QuestionnaireEditModule.SET_DATALIST_COMPONENTS(this.dataList2);
  }

  // $ 拖拽組件
  private checkMove() {
    QuestionnaireEditModule.SET_DATALIST_COMPONENTS(this.dataList);
  }

  // $ 选择组件
  private async itemClick(item: any, index: number) {
    QuestionnaireEditModule.SET_INDEX_COMPONENTS(index);
  }

  // $ 提交按钮
  private previewSubmit() {
    QuestionnaireEditModule.SET_SUBMIT_DATA();
  }

  // $ 删除组件
  private handleDelete(type: string, index?: number) {
    if (type === "unique") {
      const deleteUniqueArray = () => {
        try {
          this.dataList2.forEach((item: any, index: number) => {
            if (this.uniqueArr.includes(item.componentName)) {
              QuestionnaireEditModule.SET_DELETE_COMPONENTS(index);
              deleteUniqueArray();
              new Error("跳出循环");
            }
          });
        } catch (err) {
          console.log(err);
        }
      };
      deleteUniqueArray();
    } else QuestionnaireEditModule.SET_DELETE_COMPONENTS(index);
  }

  // computeIndex(index: number, item: QuestionFromData) {
  //   if (item.componentName == DecorationType.calculator || item.componentName == DecorationType.picture || item.componentName == DecorationType.text || item.componentName == DecorationType.cutOffLine || item.componentName == DecorationType.pageGap) {
  //     return -1;
  //   }
  //   let imageNumber = 0;
  //   let temp = index;
  //   while (temp > 0) {
  //     temp = temp - 1;
  //     if (this.dataList[temp].componentName == DecorationType.picture || this.dataList[temp].componentName == DecorationType.text || this.dataList[temp].componentName == DecorationType.cutOffLine || this.dataList[temp].componentName == DecorationType.pageGap || this.dataList[temp].componentName == DecorationType.calculator) {
  //       imageNumber++;
  //     }
  //   }
  //   const idx = index - imageNumber;
  //   let tempObj = {
  //     index: index,
  //     number: idx + 1,
  //   };
  //   QuestionnaireEditModule.SET_NUMBER_INDEX(tempObj);
  //   return idx;
  // }
}
